import React, { Component } from 'react';
import {
  Auth
} from 'aws-amplify';
import Button from '@material-ui/core/Button';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default class extends Component {
  state = {
    accessToken: false,
    copied: false,
  };

  async componentDidMount() {
    Auth
      .currentSession()
      .then(({ accessToken: { jwtToken }}) => {
        this.setState({
          accessToken: jwtToken
        })
      })
    ;
  }

  copied = () => {
    this.setState({
      copied: true,
    }, () => {
      setTimeout(() => {
        this.setState({
          copied: false,
        })
      }, 1500);
    })
  };

  render() {
    if (!this.state.accessToken) {
      return (
        <Button
          color="inherit"
          disabled
        >
          Fetching Access Token
        </Button>
      )
    }

    return (
      <CopyToClipboard
        text={this.state.accessToken}
        onCopy={this.copied}
      >
        <Button
          color="inherit"
        >
          Copy Access Token
        </Button>
      </CopyToClipboard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Authentication/AccessToken.js